import { useTranslation } from 'react-i18next';
import { Switch } from '@platform/ui';
import { SysNote } from '../system/SysNote';
import { SystemPage } from '../system/SystemPage';
import { SettingRow } from './SettingRow';
import { signInDefaults } from './signInDefaults';
import { usePlatformSetting } from './usePlatformSetting';

/**
 * «Способи входу» (прототип v4 G:L8286–8390, pgAdmSignin): «Працівники й партнери» (Microsoft, Google, пароль), «Громадяни» (Дія або
 * BankID), «Політика безпеки» (двофакторна автентифікація адміністраторів, тривалість сеансу) — налаштування платформи signIn; кожна зміна
 * зберігається одразу (PUT /platform/settings/signIn лише зі зміненим ключем). Змінює лише адміністратор платформи. Під політикою — підказка
 * (поза прототипом, рішення 4): адміністратори без застосунку автентифікації підключають його на екрані входу, тож увімкнення нікого не блокує.
 */
export function AdminSignInPage() {
  const { t } = useTranslation();
  const setting = usePlatformSetting('signIn');
  const current = { ...signInDefaults.defaults, ...(setting.value && typeof setting.value === 'object' ? (setting.value as Record<string, boolean | string>) : {}) };
  const why = setting.canEdit ? undefined : t('sysAdmin.signIn.onlyAdmin');
  const toggle = (key: string, serverKey: string) => (
    <SettingRow key={key} title={t(`sysAdmin.signIn.${key}`)} desc={t(`sysAdmin.signIn.${key}Desc`)}
      control={<span title={why}><Switch checked={current[serverKey] !== false} onChange={(on) => setting.save({ [serverKey]: on })} label={t(`sysAdmin.signIn.${key}`)} disabled={!setting.canEdit} /></span>} />
  );
  return (
    <SystemPage title={t('sysPages.sections.sign-in')} sub={t('sysAdmin.signIn.sub')}>
      {why && <SysNote>{why}</SysNote>}
      <div className="sp-two">
        <div className="sp-block">
          <div className="sp-eyebrow">{t('sysAdmin.signIn.staff')}</div>
          <div className="sp-table">{signInDefaults.staff.map(([k, s]) => toggle(k, s))}</div>
        </div>
        <div className="sp-block">
          <div className="sp-eyebrow">{t('sysAdmin.signIn.citizens')}</div>
          <div className="sp-table">{signInDefaults.citizens.map(([k, s]) => toggle(k, s))}</div>
          <div className="sp-eyebrow">{t('sysAdmin.signIn.policy')}</div>
          <div className="sp-table">
            {toggle('mfaAdmins', 'mfaAdmins')}
            <SettingRow title={t('sysAdmin.signIn.session')} desc={t('sysAdmin.signIn.sessionDesc')}
              control={<select className="sp-select" value={String(current.session)} disabled={!setting.canEdit} title={why} aria-label={t('sysAdmin.signIn.session')} onChange={(e) => setting.save({ session: e.target.value })}>
                {signInDefaults.sessions.map((s) => <option key={s} value={s}>{t(`sysAdmin.signIn.sessions.${s}`)}</option>)}
              </select>} />
          </div>
          <SysNote>{t('sysAdmin.signIn.mfaHint')}</SysNote>
        </div>
      </div>
    </SystemPage>
  );
}
